module.exports = __webpack_public_path__ + "img/icon-gg.ae6eb58c.svg";